export const RS_EXTRA6_DOUBLE_CHANCE = {
  title: "Extra 6",
  dataTable: [
    // ----- DC EXTRA 6-2 -----
    {
      titleTable: "LOTO EXTRA 6",
      descriptionTable: "DRAW FIRST [first] NUMBERS AND [last] NUMBERS",
      descriptionKeyFirst: "6",
      descriptionKeyLast: "6",
      colspan: "3",
      dataTableHeader: [
        { title: "DC EXTRA [number] NUMBERS", key: "6-2", colspan: "" },
        { title: "MULTIPLIER", key: "", colspan: "2" },
      ],
      dataTableContent: [
        {
          number: "",
          first: "FIRST [number] NUMBERS",
          last: "LAST [number] NUMBERS",
          keyNumber: "",
          keyFirst: "6",
          keyLast: "6",
        },
        {
          number: "[number] numbers",
          first: "100",
          last: "65",
          keyNumber: "2",
          keyFirst: "",
          keyLast: "",
        },
      ],
    },
    // ----- DC EXTRA 6-3 -----
    {
      titleTable: "",
      descriptionTable: "",
      descriptionKeyFirst: "",
      descriptionKeyLast: "",
      colspan: "3",
      dataTableHeader: [
        { title: "DC EXTRA [number] NUMBERS", key: "6-3", colspan: "" },
        { title: "MULTIPLIER", key: "", colspan: "2" },
      ],
      dataTableContent: [
        {
          number: "",
          first: "FIRST [number] NUMBERS",
          last: "LAST [number] NUMBERS",
          keyNumber: "",
          keyFirst: "6",
          keyLast: "6",
        },
        {
          number: "[number] numbers",
          first: "930",
          last: "620",
          keyNumber: "3",
          keyFirst: "",
          keyLast: "",
        },
        {
          number: "[number] numbers",
          first: "20",
          last: "12",
          keyNumber: "2",
          keyFirst: "",
          keyLast: "",
        },
      ],
    },
    // ----- DC EXTRA 6-4 -----
    {
      titleTable: "",
      descriptionTable: "",
      descriptionKeyFirst: "",
      descriptionKeyLast: "",
      colspan: "3",
      dataTableHeader: [
        { title: "DC EXTRA [number] NUMBERS", key: "6-4", colspan: "" },
        { title: "MULTIPLIER", key: "", colspan: "2" },
      ],
      dataTableContent: [
        {
          number: "",
          first: "FIRST [number] NUMBERS",
          last: "LAST [number] NUMBERS",
          keyNumber: "",
          keyFirst: "6",
          keyLast: "6",
        },
        {
          number: "[number] numbers",
          first: "6,600",
          last: "4,400",
          keyNumber: "4",
          keyFirst: "",
          keyLast: "",
        },
        {
          number: "[number] numbers",
          first: "185",
          last: "125",
          keyNumber: "3",
          keyFirst: "",
          keyLast: "",
        },
        {
          number: "[number] numbers",
          first: "10",
          last: "6",
          keyNumber: "2",
          keyFirst: "",
          keyLast: "",
        },
      ],
    },
    // ----- DC EXTRA 6-5 -----
    {
      titleTable: "",
      descriptionTable: "",
      descriptionKeyFirst: "",
      descriptionKeyLast: "",
      colspan: "3",
      dataTableHeader: [
        { title: "DC EXTRA [number] NUMBERS", key: "6-5", colspan: "" },
        { title: "MULTIPLIER", key: "", colspan: "2" },
      ],
      dataTableContent: [
        {
          number: "",
          first: "FIRST [number] NUMBERS",
          last: "LAST [number] NUMBERS",
          keyNumber: "",
          keyFirst: "6",
          keyLast: "6",
        },
        {
          number: "[number] numbers",
          first: "66,000",
          last: "44,000",
          keyNumber: "5",
          keyFirst: "",
          keyLast: "",
        },
        {
          number: "[number] numbers",
          first: "3,300",
          last: "2,200",
          keyNumber: "4",
          keyFirst: "",
          keyLast: "",
        },
        {
          number: "[number] numbers",
          first: "70",
          last: "40",
          keyNumber: "3",
          keyFirst: "",
          keyLast: "",
        },
        {
          number: "[number] numbers",
          first: "5",
          last: "3",
          keyNumber: "2",
          keyFirst: "",
          keyLast: "",
        },
      ],
    },
  ],
};

export const RS_EXTRA7_DOUBLE_CHANCE = {
  title: "Extra 7",
  dataTable: [
    // ----- DC EXTRA 7-2 -----
    {
      titleTable: "LOTO EXTRA 7",
      descriptionTable: "DRAW FIRST [first] NUMBERS AND [last] NUMBERS",
      descriptionKeyFirst: "7",
      descriptionKeyLast: "7",
      colspan: "3",
      dataTableHeader: [
        { title: "DC EXTRA [number] NUMBERS", key: "7-2", colspan: "" },
        { title: "MULTIPLIER", key: "", colspan: "2" },
      ],
      dataTableContent: [
        {
          number: "",
          first: "FIRST [number] NUMBERS",
          last: "LAST [number] NUMBERS",
          keyNumber: "",
          keyFirst: "7",
          keyLast: "7",
        },
        {
          number: "[number] numbers",
          first: "75",
          last: "50",
          keyNumber: "2",
          keyFirst: "",
          keyLast: "",
        },
      ],
    },
    // ----- DC EXTRA 7-3 -----
    {
      titleTable: "",
      descriptionTable: "",
      descriptionKeyFirst: "",
      descriptionKeyLast: "",
      colspan: "3",
      dataTableHeader: [
        { title: "DC EXTRA [number] NUMBERS", key: "7-3", colspan: "" },
        { title: "MULTIPLIER", key: "", colspan: "2" },
      ],
      dataTableContent: [
        {
          number: "",
          first: "FIRST [number] NUMBERS",
          last: "LAST [number] NUMBERS",
          keyNumber: "",
          keyFirst: "7",
          keyLast: "7",
        },
        {
          number: "[number] numbers",
          first: "750",
          last: "500",
          keyNumber: "3",
          keyFirst: "",
          keyLast: "",
        },
        {
          number: "[number] numbers",
          first: "10",
          last: "6",
          keyNumber: "2",
          keyFirst: "",
          keyLast: "",
        },
      ],
    },
    // ----- DC EXTRA 7-4 -----
    {
      titleTable: "",
      descriptionTable: "",
      descriptionKeyFirst: "",
      descriptionKeyLast: "",
      colspan: "3",
      dataTableHeader: [
        { title: "DC EXTRA [number] NUMBERS", key: "7-4", colspan: "" },
        { title: "MULTIPLIER", key: "", colspan: "2" },
      ],
      dataTableContent: [
        {
          number: "",
          first: "FIRST [number] NUMBERS",
          last: "LAST [number] NUMBERS",
          keyNumber: "",
          keyFirst: "7",
          keyLast: "7",
        },
        {
          number: "[number] numbers",
          first: "3,600",
          last: "2,500",
          keyNumber: "4",
          keyFirst: "",
          keyLast: "",
        },
        {
          number: "[number] numbers",
          first: "110",
          last: "70",
          keyNumber: "3",
          keyFirst: "",
          keyLast: "",
        },
        {
          number: "[number] numbers",
          first: "7",
          last: "5",
          keyNumber: "2",
          keyFirst: "",
          keyLast: "",
        },
      ],
    },
    // ----- DC EXTRA 7-5 -----
    {
      titleTable: "",
      descriptionTable: "",
      descriptionKeyFirst: "",
      descriptionKeyLast: "",
      colspan: "3",
      dataTableHeader: [
        { title: "DC EXTRA [number] NUMBERS", key: "7-5", colspan: "" },
        { title: "MULTIPLIER", key: "", colspan: "2" },
      ],
      dataTableContent: [
        {
          number: "",
          first: "FIRST [number] NUMBERS",
          last: "LAST [number] NUMBERS",
          keyNumber: "",
          keyFirst: "7",
          keyLast: "7",
        },
        {
          number: "[number] numbers",
          first: "33,000",
          last: "22,000",
          keyNumber: "5",
          keyFirst: "",
          keyLast: "",
        },
        {
          number: "[number] numbers",
          first: "1,800",
          last: "1,300",
          keyNumber: "4",
          keyFirst: "",
          keyLast: "",
        },
        {
          number: "[number] numbers",
          first: "25",
          last: "15",
          keyNumber: "3",
          keyFirst: "",
          keyLast: "",
        },
        {
          number: "[number] numbers",
          first: "4",
          last: "2",
          keyNumber: "2",
          keyFirst: "",
          keyLast: "",
        },
      ],
    },
  ],
};
